const DropdownItemRenderer = ({ api, valueFormatted }) => (
    <div
        style={{
            display: "inline-block",
            width: `calc(${
                api.columnModel.gridColumnsMap[
                    api.getFocusedCell().column.colId ??
                        api.getFocusedCell().column.field
                ].actualWidth
            }px - 32px)`,
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }}
    >
        {valueFormatted}
    </div>
);

export default DropdownItemRenderer;
